import BaseModel from '@core/model';

export class RatePlanEntry extends BaseModel {
    static name = 'RatePlanEntry';
    static entity = 'ratePlanEntries';

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            from_amount: this.attr(this.defaultMoney).nullable(),
            to_amount: this.attr(this.defaultMoney).nullable(),
            from_quantity: this.number(null).nullable(),
            to_quantity: this.number(null).nullable(),
            rate: this.number(null).nullable(),
            rate_per_unit: this.attr(null).nullable(),
            split_rates: this.boolean(false),
            minimum_fee: this.attr(null).nullable(),
            eis_rate: this.number(null).nullable(),
            vct_rate: this.number(null).nullable(),
            iht_rate: this.number(null).nullable(),
            pmi_rate: this.number(null).nullable(),
            other_rate: this.number(null).nullable(),
            eis_rate_per_unit: this.attr(null).nullable(),
            vct_rate_per_unit: this.attr(null).nullable(),
            iht_rate_per_unit: this.attr(null).nullable(),
            pmi_rate_per_unit: this.attr(null).nullable(),
            other_rate_per_unit: this.attr(null).nullable()
        };
    }

    static mock(overrides = {}) {
        return {
            id: faker => faker.string.uuid(),
            from_amount: () => ({ amount: 0, currency: 'GBP' }),
            to_amount: () => null,
            from_quantity: () => 0,
            to_quantity: () => null,
            rate: () => 0.25,
            rate_per_unit: () => null,
            split_rates: () => false,
            minimum_fee: () => null,
            eis_rate: () => null,
            vct_rate: () => null,
            iht_rate: () => null,
            pmi_rate: () => null,
            other_rate: () => null,
            eis_rate_per_unit: () => null,
            vct_rate_per_unit: () => null,
            iht_rate_per_unit: () => null,
            pmi_rate_per_unit: () => null,
            other_rate_per_unit: () => null,
            ...overrides
        };
    }
}

export default RatePlanEntry;
